import { IpaType } from "../phonemes/ipa";
import { PhoneLengths } from "../rules/lengthRules";
import { meSpeakOptions } from "../speak/meSpeak";
import { speakPhonemes } from "../speak/speakPhonemes";

/** same as speakPhonemes except that it says stuff when there's no string */
export function speakPhonemes2(input: string, addLengths?: PhoneLengths
): { approxIpa: IpaType, unsupported: string[] | undefined } {
  let overrides: meSpeakOptions | undefined;

  if (input === '' && which < script.length) {
    input = script[which].line;
    overrides = script[which].voice;
    which++;
    return speakPhonemes(input, overrides);
  }

  return speakPhonemes(input, overrides, addLengths);
}

const voice1: meSpeakOptions = { variant: 'f5', pitch: 40 };
const voice2a: meSpeakOptions = { variant: 'm1', pitch: 0, speed: 50, wordgap: 1 };
const voice2b: meSpeakOptions = { variant: 'm1', pitch: 0, speed: 90 };
const voice3: meSpeakOptions = { variant: 'f2', pitch: 80, speed: 160 };
const voice4: meSpeakOptions = { variant: 'whisperf' };

let which = 0;
interface Line { voice: meSpeakOptions, line: IpaType };
const script: Line[] = [
  { voice: voice1, line: 'wɒh ʃʊd ɔɪ̯ ˈseɪ̯' },  // what %should %I say
  { voice: voice1, line: 'ju ˈtɪɫ mi wɒh tə seɪ̯ bɔɪ̯ pʊtɪŋ ˈtɪkst ɪn və ˈtɪkst bɒks' },  // %you tell %me what to %say %by %putting text %in the text %box
  { voice: voice1, line: 'və ˈtɪkst ˈbɒks ɪz ˈɪmptɪ' }, // the text box %is empty
  { voice: voice1, line: 'ˈvʌt ˈminz ju ˈnid tə ˈpʊt ˈtɪkst ɪn ɪt' }, // that means %you need to put text %in %it
  { voice: voice1, line: 'ˈɪts ˈstɪɫ ˈɪmptɪ' }, // it's still empty
  { voice: voice1, line: 'ɪts ˈstɪːɫ ɪmptɪ' }, // %it's +still %empty
  { voice: voice1, line: 'ˈjoɹ nɒt ivɪn ˈˈtɹɔɪ̯ɪŋ , ˈɑɹ ju' }, // you're %not %even *trying, are %you
  { voice: voice1, line: 'ˈstɒp ˈpoːkɪŋ və ˈbʊːtən' }, // stop poking the button
  { voice: voice1, line: 'ˈɔɪ̯m ˈɡoːɪn tə ˈɫiːv ɪf ju doːn ˈstɒp' }, // I'm going to +leave %if %you %don't stop
  { voice: voice1, line: 'ˈoːˈkʌɪ̯ , ˈvʌts ˈɪt , ˈɔɪ̯m ˈdʊːn' }, // ok, that's it, I'm done

  { voice: voice2a, line: 'ˈju ˈɹæŋ?' }, // you rang?
  { voice: voice2b, line: 'aɪ̯ɫ ˈɡɛt ðə̆ ˈmɪstɹə̆s' }, // %I'll get the mistress

  { voice: voice3, line: 'kaːn ɜi̯ ˈɛɫp juː ?' }, // %can %I help %you?
  { voice: voice3, line: 'hwət duː juː ɪkspɛkt ˈmiː tə duː əbɑ̟u̯t ɪ̞t' }, // %what %do %you %expect me %to %do %about %it
  { voice: voice3, line: 'ɜi̯ɫ ɡɛt mɜi̯ ˈsɛːɹvɛnt tə ɛɫp' }, // %I'll %get %my servent %to %help

  { voice: voice4, line: 'wɒh ˈdʉː jˈuː nˈiːd' }, // what do you need
  { voice: voice4, line: 'ɪnsəfˈɪʃənt ˈɪnpʊt̪' }, // insufficient input
  { voice: voice4, line: 'ˈaɪ̯ wˈɪl nˈaʊ̯ stˈɒp ʊntˈɪl jˈuː pɹəvˈaɪ̯d ˈɪnpʊt̪' }, // I will now stop until you provide input
  { voice: voice4, line: 'ɐpˈæɹəntli jˈuː dˈɪd nɒh nˈɛʉ̯ɾɪs d̪ah ˈaɪ̯ ˈav stˈɒpt' }, // apparently you did not notice that I have stopped
  { voice: voice4, line: 'd̪ah mˈiːnz d̪ah ˈaɪ̯ ˈam ˈnɛʉ̯ lˈɒŋɡə ɹɪspˈɒndn̩' }, // that means that I am no longer responding
  { voice: voice4, line: 'ˈaɪ̯ ˈam nɒh lˈɪsənɪn' }, // I am not listening
  { voice: voice4, line: 'ˈɫɑː ˈɫɑː ˈɫɑː ˈɫɑː , nɒh lˈɪsənɪn' }, // la la la la, not listening
  { voice: voice4, line: 'ˈaɪ̯ ˈam ɡˈɛʉ̯ʔn̩ tə tˈeːn misˈɛlf ˈɒf naʊ̯' }, // I am going to turn myself off now
  { voice: voice4, line: 'klˈɪx' }, // click
  { voice: voice4, line: 'd̪ah wəz ˈd̪ʊ sˈaʊ̯nd ˈɒv mˈiː tˈeːnɪn ˈɒf' }, // that was the sound of me turning off
  { voice: voice4, line: 'ˈaɪ̯ ˈam ˈɒf' }, // I am off
  { voice: voice4, line: 'd̪ah mˈiːnz ˈaɪ̯ ˈkanaːθ ɹɪspˈɒnd .' }, // that means I cannot respond.
  { voice: voice4, line: 'ˈaɪ̯ ˈam stˈɪl ˈɒf' }, // I am still off
  { voice: voice4, line: 'ˈɒf' }, // off
  { voice: voice4, line: 'ɡˈɛʉ̯ ɐwˈeɪ̯ nˈaʊ̯' }, // go away now
  { voice: voice4, line: 'klˈɪx' }, // click
];
